export default {
  activateLandingPageTitle: 'Événements',
  activateProductCardTitle: 'Événements',
  activateProductPageTitle: 'Réserver des événements',
  allProductsLandingPageTitle: 'Réserver des expériences uniques',
  apply: 'Appliquer',
  buyTickets: 'Acheter des billets',
  cancel: 'Annuler',
  clear: 'Effacer',
  clearFilters: 'Effacer les filtres',
  discoverExperiences: 'Découvrir des expériences',
  exclusive: 'Exclusif',
  experience: 'expérience',
  experiencePhotoOfListing:
    "Photo de l'expérience {{photoNumber}} de l'annonce {{listingTitle}}",
  experiences: 'expériences',
  filterExperiences: 'Filtrer les expériences',
  fromListingCard: 'De',
  hostedBy: 'Organisé par',
  hostLandingPageTitle: 'Expériences locales',
  hostProductCardTitle: 'Expériences locales',
  hostProductPageTitle: 'Réserver des expériences locales',
  landingPageTitle: 'Réserver des expériences uniques',
  mainLandingPageTitle: 'Toutes les expériences',
  more: 'Plus',
  noExperiencesFound: 'Aucune expérience trouvée',
  noExperiencesFoundFor: 'Aucune expérience trouvée pour',
  experiencesFoundCount: '{{count}} expériences trouvées',
  profileImageOfHost: "Photo de profil de l'hôte {{hostName}}",
  reserve: 'Réserver',
  reserveLandingPageTitle: 'Activités et services',
  reserveProductCardTitle: 'Activités',
  reserveProductPageTitle: 'Réserver des activités et services',
  resultsPageTitle: 'Réserver des expériences et activités',
};
